import { render, staticRenderFns } from "./NewFirstVisit.vue?vue&type=template&id=54143c9e&scoped=true&"
import script from "./NewFirstVisit.vue?vue&type=script&lang=js&"
export * from "./NewFirstVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54143c9e",
  null
  
)

/* custom blocks */
import block0 from "./NewFirstVisit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports